export default __webpack_public_path__ + "static/media/cloud-snow.6dfafcee.svg";